import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';
import { useCallback, useMemo, useTransition } from 'react';
import { BuilderSkill } from '@/modules/__generated__/graphql/switchboard-generated';
const filtersConfig = {
  search: parseAsString.withDefault('').withOptions({
    shallow: false,
    history: 'replace',
    limitUrlUpdates: {
      method: 'debounce',
      timeMs: 300
    }
  }),
  skills: parseAsArrayOf(parseAsStringEnum(Object.values(BuilderSkill))).withDefault([]).withOptions({
    shallow: false,
    history: 'replace',
    limitUrlUpdates: {
      method: 'debounce',
      timeMs: 100
    }
  })
} as const;
function useBuildersFilters() {
  const $ = _c(18);
  const [filters, setFilters] = useQueryStates(filtersConfig);
  const [isSearchPending, startSearchTransition] = useTransition();
  const [isSkillsPending, startSkillsTransition] = useTransition();
  const [isResetPending, startResetTransition] = useTransition();
  let t0;
  if ($[0] !== setFilters) {
    t0 = async (key, value, options) => setFilters(previous => ({
      [key]: typeof value === "function" ? value(previous[key]) : value
    }), options);
    $[0] = setFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setFilterValue = t0;
  let t1;
  if ($[2] !== setFilterValue) {
    t1 = (value_0, options_0) => {
      startSearchTransition(async () => {
        await setFilterValue("search", value_0, options_0);
      });
    };
    $[2] = setFilterValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setSearch = t1;
  let t2;
  if ($[4] !== setFilterValue) {
    t2 = (value_1, options_1) => {
      startSkillsTransition(async () => {
        await setFilterValue("skills", value_1, options_1);
      });
    };
    $[4] = setFilterValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setSkills = t2;
  let t3;
  if ($[6] !== setFilters) {
    t3 = () => {
      startResetTransition(async () => {
        await setFilters({
          search: "",
          skills: []
        });
      });
    };
    $[6] = setFilters;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onReset = t3;
  const isResetDisabled = isSearchPending || isSkillsPending || isResetPending || filters.search === "" && filters.skills.length === 0;
  let t4;
  if ($[8] !== filters.search || $[9] !== filters.skills || $[10] !== isResetDisabled || $[11] !== isResetPending || $[12] !== isSearchPending || $[13] !== isSkillsPending || $[14] !== onReset || $[15] !== setSearch || $[16] !== setSkills) {
    t4 = {
      search: filters.search,
      skills: filters.skills,
      isSearchPending,
      isSkillsPending,
      isResetPending,
      isResetDisabled,
      setSearch,
      setSkills,
      onReset
    };
    $[8] = filters.search;
    $[9] = filters.skills;
    $[10] = isResetDisabled;
    $[11] = isResetPending;
    $[12] = isSearchPending;
    $[13] = isSkillsPending;
    $[14] = onReset;
    $[15] = setSearch;
    $[16] = setSkills;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export { useBuildersFilters };